import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Connects to data-controller="template-treatment-plan"
export default class extends Controller {
  static targets = ["notes", "templateSelect"]

  connect() {
    this.boundTrixInitialized = this.trixInitialized.bind(this)
    document.addEventListener("trix-initialize", this.boundTrixInitialized)
  }

  disconnect() {
    document.removeEventListener("trix-initialize", this.boundTrixInitialized)
  }

  trixInitialized(event) {
    if (this.notesTarget.contains(event.target)) {
      this.trixEditor = event.target
    }
  }

  async loadTemplate() {
    const templateId = this.templateSelectTarget.value
    if (!templateId) return

    try {
      const response = await get(
        `/student/templates/${templateId}/content`,
        { responseKind: "json" }
      )

      if (!response.ok) {
        console.error("error carga plantilla ", response.statusCode)
        return
      }

      const data = await response.json

      const editor =
        this.trixEditor ||
        this.notesTarget.querySelector("trix-editor")

      if (editor?.editor) {
        editor.editor.loadHTML(data.content)
      } else {
        console.error("editor trix no inicializado")
      }
    } catch (error) {
      console.error("error al cargar la plantilla:", error)
    }
  }
}
